<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Select text track</div>
    <div class="modal-body">
      @for (rendition of renditions; track rendition) {
        <div class="form-check" aria-label="Select Stream Type"
          >
          <input type="radio" class="form-check-input" id="radio{{rendition}}" name="type" [value]="rendition.id"
            [(ngModel)]="currentlySelectedRendition">
          <label class="form-check-label" for="radio{{rendition}}">
            @if (streamTypeHLS) {
              {{ rendition?.track.label }}
            }
            @if (streamTypeDASH) {
              {{ rendition?.track | formatTrackLanguage }} {{ rendition?.track.kind }}
            }
          </label>
        </div>
      }
      <div class="form-check" aria-label="Select Stream Type"
        >
        <input type="radio" class="form-check-input" id="radio_none" name="type" [value]="-1"
          [(ngModel)]="currentlySelectedRendition">
        <label class="form-check-label" for="radio_none">None
        </label>
      </div>

    </div>
    <div class="modal-footer">
      <span class="modal-footer-left cl-spacing-box cl-spacing-none">
        <button class="btn cl-color-secondary it-cancel" (click)="dialogRef.close()">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-right cl-spacing-box cl-spacing-none">
        <button class="btn cl-color-primary" (click)="dialogRef.close(currentlySelectedRendition)">
          <span>Select</span>
        </button>
      </span>
    </div>
  </div>
</div>
